<template>
    <div class="slider-video" >
        <div class="container">
            <div class="row d-flex justify-content-center">
                <h2 class="font-glacial-regular video-titulo mt-lg-5">
                    {{data.titulo}}
                </h2>
            </div>
            <!-- <div class="row d-flex justify-content-center">
                <h2 class="font-glacial-regular text-gray-light text-center video-subtitulo">
                    {{data.descricao}}
                </h2>
            </div> -->
            <div ref="observerVideos"></div>
            <transition enter-active-class="animated fadeInUp">
                <slick :options="slickOptions" v-if="showObserver">
                    <div v-for="(d, index) in posts" :key="index" v-if="d.better_featured_image">
                        <div class="col-xl-10 d-flex justify-content-center align-items-center mx-auto video-image" :style="`border-radius: 10px; background-image: url(${d.better_featured_image.source_url})`">
                            <div class="btn-play-mobile btn-play-large" @click="showVideo(d.acf.id_video)"></div>
                        </div>
                        <div class="col-12">
                            <p class="text-center font-glacial-regular font-20 text-white" v-html="d.title.rendered"></p>
                        </div>
                    </div>
                </slick>
            </transition>

            <b-modal @show="play = true" @hide="play = false" ref="modal" body-class="p-0" size="lg" hide-footer hide-header centered title="Using Component Methods">
                <iframe width="100%" height="400px" :src="`https://www.youtube.com/embed/${link}?&autoplay=1`" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen v-if="play"></iframe>
            </b-modal>

            <div class="row d-flex justify-content-center pb-5">
                <b-button variant="ver-todos" class="col-xl-2 mb-1 mt-5 btn-opacidade" to="/videos"></b-button>
            </div>
            
        </div>
    </div>
</template>
<script>
import observer from 'intersection-observer';

export default {
    props:{
        data: null
    },
    data(){
        return {
            link: null,
            showObserver: false,
            posts: [],
            show: false,

            slickOptions:{
                arrows: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings:{
                            arrows: false,
                        }
                    }
                ]
            },
            play: false,
        }
    },

    mounted(){
        var observer = new IntersectionObserver((entries) => {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) {
                return;
            }
            this.showObserver = true
            observer.unobserve(this.$refs.observerVideos)

        });
        observer.POLL_INTERVAL = 100;
        observer.observe(this.$refs.observerVideos)

        var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&categories=8&order_by=rand&per_page=5"

        axios.get(url).then(response => {
            this.total = response.headers["x-wp-total"]
            this.posts = response.data
        })

        this.data.videos.forEach(e => {
            this.loadImg(e.foto_video.url)
        });
    },

    methods:{
        async loadImg(url){
            let img = new Image();
            img.src = url
        },

        showVideo(id){
            this.link = id;

            this.$refs.modal.show()
        },
    }
    
}
</script>




// WEBPACK FOOTER //
// src/components/widgets/slider_video.vue